export function formatBalloonCount(count: number, limit = 9): string {
  return count > limit ? `${limit}+` : String(count);
}
